var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-table__body"},_vm._l((_setup.props?.dado?.aditivos),function(aditivo){return _c(_setup.LinhaDeAditivo,{key:aditivo.id,attrs:{"dado":_setup.props?.dado,"aditivo":aditivo},on:{"update:alteraAditivo":_setup.alteraAditivo}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }